import { Component, inject } from '@angular/core';
import { NavigatorComponent } from './features/navigator/navigator/navigator.component';
import { LoadingScreenComponent } from '@rillion/core/loading-screen/loading-screen.component';
import { AsyncPipe } from '@angular/common';
import { InitializeService } from '@rillion/core/services/initialize.service';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [NavigatorComponent, LoadingScreenComponent, AsyncPipe],
})
export class AppComponent {
  private readonly initializationService = inject(InitializeService);

  appComponentInitializing$ = this.initializationService.appComponentInitializing$;
}
